import { render, staticRenderFns } from "./RandomDisplay.vue?vue&type=template&id=c1af366c&scoped=true&"
import script from "./RandomDisplay.vue?vue&type=script&lang=js&"
export * from "./RandomDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RandomDisplay.vue?vue&type=style&index=0&id=c1af366c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1af366c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
